import invariant from 'invariant'
import { useSelector } from 'react-redux'
import {
  LoggedInSessionStateT,
  SessionStateT,
  ApplicationStateT,
} from '../../types'

function useLoggedInSession(): LoggedInSessionStateT {
  const session = useSelector<ApplicationStateT, SessionStateT>(
    ({ session }) => session
  )

  invariant(
    session.sessionState === 'loggedIn',
    `Expected session state to be "loggedIn" but was "${session.sessionState}".`
  )

  return session
}

export default useLoggedInSession
